// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"D0-z"};